export type ChatRealtimeEventType =
  | 'CONNECTED'
  | 'MESSAGE_CREATED'
  | 'MESSAGE_READ'
  | 'STATUS_UPDATED'
  | 'FAVORITE_UPDATED'
  | 'TYPING'
  | 'STOP_TYPING'
  | 'CONVERSATION_UPDATED';

export interface ChatRealtimeEvent<T = any> {
  type: ChatRealtimeEventType;
  payload: T;
  createdAt?: string;
}

export interface ChatRealtimeClientOptions {
  endpoint?: string;
  onOpen?: () => void;
  onClose?: () => void;
  onError?: (error: Event) => void;
  onEvent: (event: ChatRealtimeEvent) => void;
}

function resolveRealtimeEndpoint(endpoint?: string) {
  if (endpoint) return endpoint;
  const apiBase = (import.meta.env.VITE_API_URL || '/api/v1').replace(/\/$/, '');
  return `${apiBase}/chat-interno/realtime`;
}

export function createChatRealtimeClient(options: ChatRealtimeClientOptions) {
  const url = resolveRealtimeEndpoint(options.endpoint);
  const source = new EventSource(url, { withCredentials: true });

  source.onopen = () => {
    options.onOpen?.();
  };

  source.onerror = (error) => {
    options.onError?.(error);
  };

  source.addEventListener('message', (event) => {
    try {
      options.onEvent(JSON.parse(event.data));
    } catch {
      // evento inválido ignorado para não quebrar o chat
    }
  });

  source.addEventListener('chat', (event) => {
    try {
      options.onEvent(JSON.parse((event as MessageEvent).data));
    } catch {
      // evento inválido ignorado
    }
  });

  return {
    close: () => {
      source.close();
      options.onClose?.();
    },
  };
}
